module.exports = __webpack_public_path__ + "static/media/speechbubble2.32df9f0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/speechbubble2.svg
// module id = 340
// module chunks = 0